// extracted by mini-css-extract-plugin
export default {"primaryPracticalBlue":"#141b4d"};